<template>
  <b-container fluid>
    <b-card
      border-variant="danger"
      :header="$t('AddFilterTag.header')"
      header-bg-variant="danger"
      header-text-variant="white"
      align="left"
    >
      <div>
        <b-tabs content-class="mt-3" v-model="tabIndex">
          <b-tab v-for="(lang, i) in langOptions" :key="i">
            <template v-slot:title>
              <country-flag :country="getLocale(lang)" size="normal" />
            </template>
          </b-tab>
        </b-tabs>
      </div>

      <div>
        <div v-for="(n, i) in form.name" :key="i">
          <b-row align-v="center" v-if="n.lang === selectedLanguage">
            <b-col>
              <b-form-group :label="$t('AddFilterTag.name')">
                <b-form-input type="text" v-model="n.value" required></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-row class="mt-3 justify-content-center">
        <b-col>
          <b-button
            variant="secondary"
            type="submit"
            class="float-right"
            @click="$router.push({name: 'EditFilterTags'})"
          >{{ $t('AddFilterTag.cancel') }}</b-button>
        </b-col>
        <b-col>
          <b-button
            variant="danger"
            type="submit"
            @click="checkFieldsAndSave"
          >{{ $t('AddFilterTag.save') }}</b-button>
        </b-col>
      </b-row>
      <b-row class="mt-3 justify-content-center">
        <b-alert :show="error.received" variant="danger" class="text-center">{{error.msg}}</b-alert>
      </b-row>
      <b-row v-if="error.showLink" class="justify-content-center">
        <router-link :to="{name: 'EditFilterTags'}">{{ $t('AddFilterTag.editFilterTagsPageLink') }}</router-link>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
/* CONTROLLER */
import locales from '../i18n/locales'
import FilterTagsService from '@/services/FilterTagsService'
import HelperFunctions from '@/extras/HelperFunctions'

export default {
  name: 'AddFilterTag',
  data () {
    return {
      error: {
        received: false,
        msg: '',
        showLink: false
      },
      form: {
        name: []
      },
      langOptions: [],
      selectedLanguage: this.$i18n.locale,
      tabIndex: 0
    }
  },
  mounted () {
    // redirect if user not logged in
    let smartdineLocalStorage = JSON.parse(
      window.localStorage.getItem('smartdine')
    )
    if (!smartdineLocalStorage.token) this.$router.push({ name: 'Login' })
    else {
      this.restructureFormObject()
      this.languageOptions()
      this.selectedLanguage = this.langOptions[this.tabIndex].value
    }
  },
  methods: {
    restructureFormObject () {
      let name = []

      Object.keys(this.$i18n.messages).forEach(l => {
        name.push({ lang: l, value: null })
      })

      // assign to form
      this.form.name = name
    },
    async saveItem () {
      try {
        await FilterTagsService.addFilterTag(this.form)

        // navigate back to EditFilterTags
        this.$router.push({ name: 'EditFilterTags' })
      } catch (error) {
        this.error.received = true
        this.error.showLink = true
        this.error.msg = error.response.data.error
      }
    },
    checkFieldsAndSave () {
      // take out any null lang/value objects
      if (!HelperFunctions.areAllValuesNullEmpty(this.form.name)) {
        this.form.name = this.filterNulls(this.form.name)
        this.saveItem()
      } else {
        this.error.received = true
        this.error.showLink = true
        this.error.msg = this.$i18n.t('AddFilterTag.declareName')
      }
    },
    languageOptions () {
      // get languages from i18n and assign value/text to langOptions
      this.langOptions = Object.keys(this.$i18n.messages).map(l => {
        return { value: l, text: l.toUpperCase() }
      })
    },
    filterNulls (obj) {
      return obj.filter(el => {
        return el.value !== null && el.value !== ''
      })
    },
    getLocale (lang) {
      return locales.filter(l => l.code === lang.value)[0].flag
    }
  },
  watch: {
    tabIndex () {
      if (this.tabIndex !== -1) {
        this.selectedLanguage = this.langOptions[this.tabIndex].value
      }
    }
  }
}
</script>

<style scoped>
.btn {
  margin: 0.1em 0.25em 0.1em 0.25em;
}

.modal-dialog h3 {
  color: #0d47a1;
}
.badge {
  line-height: 1.5em;
}
.variants {
  margin-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/AddFilterTag.vue